import { Slide, ToastContainer } from 'react-toastify';
import type { IconProps } from 'react-toastify';
import React from 'react';
import { TOAST_AUTO_CLOSE_DURATION } from '../utils/constants';

function renderToastIcon({ type }: IconProps) {
  switch (type) {
    case 'success':
      return <img src="/assets/icons/check_green_2.svg" alt="Success Icon" />;
    case 'warning':
      return <img src="/assets/icons/warning.svg" alt="Warning Icon" />;
    case 'error':
      return <img src="/assets/icons/x_red.svg" alt="Error Icon" />;
    case 'info':
      return <img src="/assets/icons/blue_exclamation.svg" alt="Information Icon" />;
    default:
      return null;
  }
}

export default function AppToastContainer() {
  return (
    <ToastContainer
      position="bottom-right"
      transition={Slide}
      autoClose={TOAST_AUTO_CLOSE_DURATION}
      icon={renderToastIcon}
    />
  );
}
